import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import type { Message } from 'primeng/api';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';

@Injectable()
export class AlertControlFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Requests">

  requestAddError(result: any,
                  detail: string | null = null) {
    this.requestAddAlert({
      key: 'main',
      id: result.error?.uuid,
      detail: detail || result.error?.message || result.message,
      severity: FlatModels.ErrorControlModels.ErrorLevelAlertType[result.level as FlatModels.ErrorControlModels.ErrorLevel] || FlatModels.AlertControlModels.AlertType.enum.error,
      life: FlatModels.AlertControlModels.AlertTime.DEFAULT
    });
  }
  
  requestAddAlert(message: Message) {
    return this.store.dispatch(new FlatActions.AlertControlActions.AddAlert(message));
  }

  requestClearAlerts() {
    return this.store.dispatch(new FlatActions.AlertControlActions.ClearAlerts());
  }

  //</editor-fold>
}
